import React from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../routes";

const LOAN_CALCULATOR_TABS = [
  { to: ROUTES.carAffordability, label: "Car Affordability" },
  { to: ROUTES.homeAffordability, label: "Home Affordability" },
  { to: ROUTES.bondRepayment, label: "Bond Repayment" },
] as const;

/** Route-linked tabs for car / home affordability and bond repayment. */
const LoanCalculatorTabs: React.FC = () => (
  <nav className="calculator-tabs" aria-label="Loan calculators">
    {LOAN_CALCULATOR_TABS.map(({ to, label }) => (
      <NavLink
        key={to}
        to={to}
        className={({ isActive }) =>
          `tab-button${isActive ? " active" : ""}`
        }
      >
        {label}
      </NavLink>
    ))}
  </nav>
);

export default LoanCalculatorTabs;
